export const ATTACHMENTS_ENDPOINT = '/c/v1/chat/attachments';
